// Contact Submission Status Options & Labels
export const CONTACT_STATUS_OPTIONS = [
  { value: 'new', label: 'New' },
  { value: 'read', label: 'Read' },
  { value: 'in_progress', label: 'In Progress' },
  { value: 'resolved', label: 'Resolved' },
  { value: 'archived', label: 'Archived' },
];

export const INQUIRY_TYPE_LABELS: Record<string, string> = {
  general: 'General',
  support: 'Support',
  partner: 'Partner',
  proposal: 'Proposal',
  feature: 'Feature',
};

// Proposal Status Labels & Colors
export const PROPOSAL_STATUS_LABELS: Record<string, string> = {
  pending: 'Pending',
  under_review: 'Under Review',
  approved: 'Approved',
  rejected: 'Rejected',
  implemented: 'Implemented',
};

export const PROPOSAL_STATUS_COLORS: Record<string, string> = {
  pending: 'bg-yellow-500/10 text-yellow-600 dark:text-yellow-400 border-yellow-500/20',
  under_review: 'bg-blue-500/10 text-blue-600 dark:text-blue-400 border-blue-500/20',
  approved: 'bg-green-500/10 text-green-600 dark:text-green-400 border-green-500/20',
  rejected: 'bg-red-500/10 text-red-600 dark:text-red-400 border-red-500/20',
  implemented: 'bg-emerald-500/10 text-emerald-600 dark:text-emerald-400 border-emerald-500/20',
};

export const PROPOSAL_TYPE_LABELS: Record<string, string> = {
  field: 'Field',
  enum_value: 'Enum',
  standard: 'Standard',
  adf_element: 'ADF Element',
  adf_mapping: 'ADF Mapping',
  adf_attribute: 'ADF Attribute',
};

export const PROPOSAL_TYPE_COLORS: Record<string, string> = {
  field: 'bg-blue-500/10 text-blue-600 dark:text-blue-400 border-blue-500/20',
  enum_value: 'bg-purple-500/10 text-purple-600 dark:text-purple-400 border-purple-500/20',
  standard: 'bg-green-500/10 text-green-600 dark:text-green-400 border-green-500/20',
  adf_element: 'bg-amber-500/10 text-amber-600 dark:text-amber-400 border-amber-500/20',
  adf_mapping: 'bg-cyan-500/10 text-cyan-600 dark:text-cyan-400 border-cyan-500/20',
  adf_attribute: 'bg-rose-500/10 text-rose-600 dark:text-rose-400 border-rose-500/20',
};

// Partner Categories (used in PartnersManager and Contact page)
export const PARTNER_CATEGORIES = [
  'DMS Provider',
  'CRM Provider',
  'Service Platform',
  'Dealer Group',
  'Integration Partner',
  'Industry Association',
  'Technology Partner',
  'Other',
];

// Data Type Doc Categories
export const DATA_TYPE_DOC_CATEGORIES = [
  { value: 'format', label: 'Format' },
  { value: 'type', label: 'Type' },
  { value: 'structure', label: 'Structure' },
];

// Partner Adoption Phases (for partners developing with the standard)
export const PARTNER_ADOPTION_PHASES = [
  { value: 'exploring', label: 'Exploring', description: 'Evaluating the standard for their systems' },
  { value: 'implementing', label: 'Implementing', description: 'Actively developing with the standard' },
  { value: 'adopted', label: 'Adopted', description: 'Fully integrated in production' },
];

// Partner Engagement Types (how they support the initiative)
export const PARTNER_ENGAGEMENT_TYPES = [
  { value: 'supporter', label: 'Supporter', description: 'Endorses the mission and initiative' },
  { value: 'contributor', label: 'Contributor', description: 'Helps build and refine standards' },
  { value: 'implementer', label: 'Implementer', description: 'Building products using the standard' },
];

// Badge color mappings
export const ADOPTION_PHASE_COLORS: Record<string, string> = {
  exploring: 'bg-amber-500/10 text-amber-600 dark:text-amber-400 border-amber-500/20',
  implementing: 'bg-blue-500/10 text-blue-600 dark:text-blue-400 border-blue-500/20',
  adopted: 'bg-green-500/10 text-green-600 dark:text-green-400 border-green-500/20',
};

export const ENGAGEMENT_TYPE_COLORS: Record<string, string> = {
  supporter: 'bg-pink-500/10 text-pink-600 dark:text-pink-400 border-pink-500/20',
  contributor: 'bg-purple-500/10 text-purple-600 dark:text-purple-400 border-purple-500/20',
  implementer: 'bg-cyan-500/10 text-cyan-600 dark:text-cyan-400 border-cyan-500/20',
};
